import React from 'react';
import classNames from 'classnames';
const { pngIcons, svgIcons } = require('./icons');

import './index.sass';

export default ({ className, name, tag: Tag = 'span', type = 'svg', ...rest}) => {
    className = classNames(className, 'icon');

    const isSvg = () => !!svgIcons[name] && type === 'svg'

    const rSvg = () => {
        const icon = svgIcons[name];
        return (
            <Tag className={className}
                 dangerouslySetInnerHTML={{__html: icon}} { ...rest} />
        )
    }

    const rPng = () => {
        const icon = pngIcons[name];
        return (
            <Tag className={ className }
                 style={{backgroundImage: `url(${icon})`}} {...rest}/>
        )
    }

    return isSvg() ? rSvg() : rPng();
}
